export const SERVICE_UNAVAILABLE_MESSAGE =
    "There seems to have been a hiccup. We've reported the issue. Please try again later.";
export const DISABLE_CAPTCHA_VALIDATION =
    process.env.REACT_APP_DISABLE_CAPTCHA_VALIDATION === 'true';
export const CHECKOUT_JS_URL = process.env.REACT_APP_CHECKOUT_JS_URL;
export const THREEDS_BASE_URL = process.env.REACT_APP_THREEDS_BASE_URL;
export const MAX_SHIP_TO_HOME_CARD_QUANTITY = 16;